import React from 'react';

const paths = {
  family: <><circle cx="8" cy="6" r="3"/><circle cx="17" cy="11" r="2.5"/><path d="M2 20v-5a6 6 0 0 1 12 0v5M14 21v-4a4 4 0 0 1 8 0v4M8 15v6"/></>,
  home: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/><path d="M9 21v-7h6v7"/></>,
  wallet: <><path d="M20 8V5a2 2 0 0 0-2-2H5a3 3 0 0 0 0 6h15v11H5a3 3 0 0 1-3-3V6"/><path d="M21 12h-5a2 2 0 0 0 0 4h5Z"/></>,
  silver: <><circle cx="8" cy="15" r="4"/><circle cx="16" cy="15" r="4"/><circle cx="12" cy="7" r="4"/></>,
  gold: <><path d="M6 6h12l4 13H2Z"/><path d="m6 6 2 8h14M8 14l-6 5"/></>,
  bar: <><rect x="5" y="2" width="14" height="20" rx="3"/><path d="m9 9 3-2 3 2v4l-3 2-3-2ZM10 18h4"/></>,
  goal: <><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><path d="m12 12 8-9M15 3h5v5"/></>,
  history: <><path d="M3 10a9 9 0 1 1 1 7M3 3v7h7"/><path d="M12 7v5l4 2"/></>,
  person: <><circle cx="12" cy="7" r="4"/><path d="M4 21v-3a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v3"/></>,
  bell: <><path d="M5 10a7 7 0 0 1 14 0v5l2 3H3l2-3Z"/><path d="M9 21h6"/></>,
  support: <><path d="M4 13v-3a8 8 0 0 1 16 0v3M20 18v1a3 3 0 0 1-3 3h-3"/><rect x="2" y="11" width="4" height="7" rx="2"/><rect x="18" y="11" width="4" height="7" rx="2"/></>,
  receipt: <><path d="M5 2v20l3-2 4 2 4-2 3 2V2l-3 2-4-2-4 2Z"/><path d="M9 8h6M9 12h6M9 16h3"/></>,
  eye: <><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></>,
  eyeOff: <><path d="m3 3 18 18M10 5c6-1 11 7 11 7l-3 4M6 6l-4 6s3 7 10 7l4-1M10 10a3 3 0 0 0 4 4"/></>,
  arrow: <path d="M20 12H4m6-6-6 6 6 6"/>,
  transfer: <><path d="M3 7h17l-4-4M21 17H4l4 4"/></>,
  delivery: <><path d="M2 4h12v13H2ZM14 9h4l4 5v3h-8"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="18" r="3"/></>,
  shield: <><path d="m12 2 8 4v6c0 5-8 10-8 10S4 17 4 12V6Z"/><path d="m8 12 3 3 5-6"/></>,
  plus: <path d="M12 4v16M4 12h16"/>,
  minus: <path d="M4 12h16"/>,
  check: <path d="m4 12 5 5L20 6"/>,
  close: <path d="m6 6 12 12M6 18 18 6"/>,
  chevron: <path d="m9 5 7 7-7 7"/>,
  menu: <path d="M4 6h16M4 12h16M4 18h16"/>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/></>,
  info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7v.01"/></>,
  replay: <><path d="M3 4v6h6M4 10a8 8 0 1 1 0 6"/></>,
};

export default function Icon({name, size=20, label, className='', ...props}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" className={`qc-icon ${className}`} aria-hidden={label ? undefined : true} role={label ? 'img' : undefined} aria-label={label} focusable="false" {...props}>{paths[name] || paths.info}</svg>;
}
